module.exports = __webpack_public_path__ + "media/Etiquetas_bajo_la_lupa.c7a24e1c.wav";